<template>
  <q-form ref="surveyForm" class="full-width q-pa-md">
    <div class="row items-center">
      <div
        v-if="!pwaVersion && formData.status != 'New' && !creatingMerge"
        class="col-12"
      >
        <q-btn
          class="full-width bg-primary text-white"
          label="Link to another Scheduled Survey"
          @click="linkToAnotherSurveyDialog = true"
        >
        </q-btn>
      </div>
      <div
        v-if="false"
        class="col-12"
        :class="{
          'q-px-sm': !pwaVersion,
        }"
      >
        <q-select
          v-if="false"
          v-model="formData.type"
          :options="surveyTypes"
          label="Survey Type"
          @input="
            delete formData.startingDepth;
            formData.depths = [];
            selectedDepths = [];
            formData.startingDepth =
              formData.type == 'Single Depth Moisture Survey' ? 250 : null;
          "
          :rules="[(v) => !!v || 'Survey Type is Required']"
          :filled="pwaVersion"
        ></q-select>
      </div>
      <div
        class="col-12"
        :class="{
          'col-md-6':
            formData.type == 'Moisture Profile Survey' ? false : false,
          'q-px-sm': !pwaVersion,
        }"
      >
        <q-input
          :filled="pwaVersion"
          v-model="formData.name"
          label="Survey Name"
          :rules="[(v) => !!v || 'Survey Name is Required']"
        ></q-input>
      </div>
      <div
        v-if="formData.type == 'Moisture Profile Survey' && false"
        class="col-12 col-md-6"
        :class="{
          'q-px-sm': !pwaVersion,
        }"
      >
        <q-select
          :filled="pwaVersion"
          v-model="formData.depthInterval"
          :options="profileLayerDepths"
          :emit-value="true"
          map-options
          @input="
            delete formData.startingDepth;
            formData.depths = [];
            selectedDepths = [];
          "
          label="Profile Layer Depth"
          :rules="[(v) => !!v || 'Survey Name is Required']"
        />
      </div>
      <div
        v-if="false"
        :class="{
          'col-md-6': formData.type == 'Moisture Profile Survey',
          'q-px-sm': !pwaVersion,
        }"
        class="col-12"
      >
        <q-select
          :filled="pwaVersion"
          ref="newFormStartingDepthField"
          v-if="formData.depthInterval != 100"
          v-model="formData.startingDepth"
          :options="startingDepths"
          :option-label="
            formData.type == 'Single Depth Moisture Survey'
              ? 'labelsp'
              : 'label'
          "
          :label="
            formData.type == 'Single Depth Moisture Survey'
              ? 'Survey Depth'
              : 'Starting Depth'
          "
          :emit-value="true"
          map-options
          :disable="
            !formData.depthInterval &&
            formData.type != 'Single Depth Moisture Survey'
          "
          @input="
            formData.depths = [];
            selectedDepths = [];
            generateDepthList();
          "
          :rules="[(v) => v >= 0 || 'Starting Depth is Required']"
        />
        <q-select
          v-else
          :filled="pwaVersion"
          v-model="formData.startingDepth"
          :options="startingDepths100mm"
          label="Starting Depth"
          :emit-value="true"
          map-options
          :disable="
            !formData.depthInterval &&
            formData.type != 'Single Depth Moisture Survey'
          "
          @input="
            formData.depths = [];
            selectedDepths = [];
            generateDepthList();
          "
          :rules="[(v) => v >= 0 || 'Starting Depth is Required']"
        />
      </div>
      <div
        class="col-12 col-md-6 q-px-sm q-mb-md"
        :class="{
          'q-px-sm': !pwaVersion,
        }"
        v-if="formData.type == 'Moisture Profile Survey' && false"
      >
        <q-btn
          :disable="
            formData.depthInterval == '' ||
            (!formData.startingDepth && formData.startingDepth != 0)
          "
          class="full-width"
          outline
          :label="`Select Depths: ${selectedDepths.length}`"
          @click="selectDepthsDialog = true"
        >
        </q-btn>
      </div>
      <div v-if="!pwaVersion" class="col-12 q-mb-none">
        <q-btn-toggle
          v-model="formData.locationType"
          spread
          toggle-color="primary"
          :options="[
            { label: 'Google', value: 'google' },
            { label: 'Manual', value: 'manual' },
          ]"
        />
        <span class="ma-0 pa-0" style="color: gray; font-size: 12px">
          <b>Google</b> option sets the location search below to a Google
          Search, <b>Manual</b> uses plain text
        </span>
      </div>
      <div
        v-if="!offlineMode && formData.locationType == 'google' && !pwaVersion"
        class="col-12"
        :class="{
          'q-pa-sm': !pwaVersion,
        }"
      >
        <places-autocomplete
          ref="googleAutoComplete"
          @placeSelected="placeSelected"
          :filled="pwaVersion"
        ></places-autocomplete>
      </div>
      <div
        v-if="formData.locationType == 'manual' && !pwaVersion"
        class="col-12"
        :class="{
          'q-pa-sm': !pwaVersion,
        }"
      >
        <q-select
          label="Starting Location"
          :filled="pwaVersion"
          :options="recentLocations"
          option-value="location"
          option-label="location"
          :emit-value="true"
          map-options
          use-input
          input-debounce="0"
          new-value-mode="add"
          v-model="formData.location"
        />
      </div>
      <div
        class="col-12 col-md-6"
        :class="{
          'q-px-sm': !pwaVersion,
          'q-pt-md': pwaVersion,
        }"
      >
        <q-input
          :filled="pwaVersion"
          v-model="formData.upperLimit"
          label="Concerning Moisture Limit"
          type="number"
          suffix="TDRI Index"
          :rules="[(v) => !!v || 'Upper Limit is Required']"
        ></q-input>
      </div>
      <div
        class="col-12 col-md-6"
        :class="{
          'q-px-sm': !pwaVersion,
          'q-pt-md': pwaVersion && $q.screen.gt.sm,
        }"
      >
        <q-input
          :filled="pwaVersion"
          v-model="formData.lowerLimit"
          label="Ideal Moisture Limit"
          type="number"
          suffix="TDRI Index"
          :rules="[(v) => !!v || 'Lower Limit is Required']"
        ></q-input>
      </div>
      <div
        class="col-12"
        :class="{
          'q-pa-sm': !pwaVersion,
        }"
      >
        <datepicker
          label="Start Date"
          :filled="pwaVersion"
          @input="(val) => (formData.date = val)"
          :value="formData.date"
          :options="dateOptionsFn"
        />
      </div>
      <div v-if="!pwaVersion" class="col-12 q-pa-sm">
        <assignUser
          :id="formData.user_id"
          @changed="(val) => (formData.user_id = val)"
        />
        <q-input
          ref="uploadDataInput"
          style="display: none"
          v-model="file"
          type="file"
          label="Standard"
          accept=".json"
        ></q-input>
      </div>
      <div v-if="!pwaVersion" class="col-12 q-pa-sm">
        <assignTrailer
          :id="formData.trailer_id"
          @changed="(val) => (formData.trailer_id = val)"
        />
      </div>
      <div v-if="!pwaVersion && !formData.id" class="col-12 q-pa-sm">
        <assign-organization
          :id="formData.organizations"
          label="Organisations"
          clearable
          multiple
          @changed="(val) => (formData.organizations = val)"
        />
      </div>
    </div>
    <q-dialog v-model="selectDepthsDialog" persistent>
      <q-card tile style="width: 600px">
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              Select Depths
            </div>
            <q-space />
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <div
              class="col-12 col-md-6 col-lg-4 q-pa-sm"
              v-for="(depth, index) in depths"
              :key="`depths_${index}`"
            >
              <q-card
                v-if="!depth.disabled"
                :class="{
                  'bg-primary': selectedDepths.includes(depth.value),
                  'text-white': selectedDepths.includes(depth.value),
                }"
                style="width: 100%; cursor: pointer"
                id="depthCard"
                @click="selectDepth(depth)"
              >
                <q-card-section>
                  <div class="text-h6">Depth: {{ depth.label }}</div>
                </q-card-section>
              </q-card>
              <q-card
                v-else
                class="bg-primary text-white"
                style="width: 100%"
                id="depthCard"
              >
                <q-card-section>
                  <div class="text-h6">Depth: {{ depth.label }}</div>
                </q-card-section>
              </q-card>
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="
                  selectDepthsDialog = false;
                  formData.depths = selectedDepths;
                "
                class="float-right"
                color="primary"
                label="Select"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="linkToAnotherSurveyDialog" persistent>
      <q-card tile style="width: 600px">
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              Select Scheduled Survey
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="linkToAnotherSurveyDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <assignScheduledSurvey
                :id="ssLinkedID"
                @changed="(val) => (ssLinkedID = val)"
              />
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="linkSurveysTogether"
                :loading="linkToAnotherSurveyLoading"
                class="float-right"
                color="primary"
                label="Link"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <!-- <q-dialog v-model="selectDepthUploadDialog" persistent>
      <q-card tile style="width: 600px">
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Select Depths
            </div>
            <q-space />
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <div
              class="col-12 col-md-6 col-lg-4 q-pa-sm"
              v-for="(depth, index) in depths"
              :key="`depths_${index}`"
            >
              <q-card
                v-if="!depth.disabled"
                :class="{
                  'bg-primary': selectedDepths.includes(depth.value),
                  'text-white': selectedDepths.includes(depth.value)
                }"
                style="width: 100%; cursor: pointer"
                id="depthCard"
                @click="selectDepth(depth)"
              >
                <q-card-section>
                  <div class="text-h6">Depth: {{ depth.label }}</div>
                </q-card-section>
              </q-card>
              <q-card
                v-else
                class="bg-primary text-white"
                style="width: 100%"
                id="depthCard"
              >
                <q-card-section>
                  <div class="text-h6">Depth: {{ depth.label }}</div>
                </q-card-section>
              </q-card>
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="
                  selectDepthsDialog = false;
                  formData.depths = selectedDepths;
                "
                class="float-right"
                color="primary"
                label="Select"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog> -->
  </q-form>
</template>

<script>
import placesAutocomplete from "@/components/googleMaps/placesAutocomplete.vue";
import moment from "moment";
import { mapGetters } from "vuex";
import datepicker from "@/components/wrappers/datepicker.vue";
import assignUser from "@/components/users/assignUser.vue";
import assignTrailer from "@/components/trailers/assignTrailer.vue";
import assignScheduledSurvey from "@/components/scheduledSurveys/assignScheduledSurvey.vue";
import assignOrganization from "@/components/organizations/assignOrganization.vue";

export default {
  components: {
    placesAutocomplete,
    datepicker,
    assignUser,
    assignTrailer,
    assignScheduledSurvey,
    assignOrganization,
  },
  computed: {
    ...mapGetters([
      "offlineMode",
      "recentLocations",
      "recentLocationsLoading",
      "survey",
    ]),
  },
  props: {
    surveyData: {
      type: Object,
      default: null,
    },
    pwaVersion: {
      type: Boolean,
      default: false,
    },
    creatingMerge: {
      type: Boolean,
      default: false,
    },
    scansToBeMerged: {
      default: null,
    },
  },
  watch: {
    surveyData: function () {
      this.init();
    },
    file: function () {
      if (this.file != null) {
        this.uploadDataReady();
      }
    },
    survey: function () {
      this.init();
    },
  },
  data: () => ({
    // Extra Data
    surveyTypes: ["Single Depth Moisture Survey", "Moisture Profile Survey"],
    profileLayerDepths: [
      {
        label: "50mm",
        value: 50,
      },
      {
        label: "100mm",
        value: 100,
      },
    ],
    startingDepths: [
      {
        label: "0mm-50mm",
        labelsp: "50mm",
        value: 0,
      },
      {
        label: "50mm-100mm",
        labelsp: "100mm",
        value: 50,
      },
      {
        label: "100mm-150mm",
        labelsp: "150mm",
        value: 100,
      },
      {
        label: "150mm-200mm",
        labelsp: "200mm",
        value: 150,
      },
      {
        label: "200mm-250mm",
        labelsp: "250mm",
        value: 200,
      },
      {
        label: "250mm-300mm",
        labelsp: "300mm",
        value: 250,
      },
    ],
    startingDepths100mm: [
      {
        label: "0mm-100mm",
        value: 0,
      },
      {
        label: "50mm-150mm",
        value: 50,
      },
      {
        label: "100mm-200mm",
        value: 100,
      },
      {
        label: "150mm-250mm",
        value: 150,
      },
      {
        label: "200mm-300mm",
        value: 200,
      },
      {
        label: "250mm-300mm",
        value: 250,
      },
    ],
    selectDepthsDialog: false,
    depths: [],
    googleAutocomplete: "",

    formData: {},
    selectedDepths: [],
    file: null,

    linkToAnotherSurveyDialog: false,
    linkToAnotherSurveyLoading: false,
    ssLinkedID: null,
  }),
  mounted() {
    this.$store.dispatch("loadUsers");
    this.$store.dispatch("loadRecentLocations");
    setTimeout(() => {
      this.init();
    }, 100);
  },
  methods: {
    init() {
      if (
        (this.surveyData != null && this.surveyData.hasOwnProperty("id")) ||
        (this.$route.params.surveys_id && this.survey.id)
      ) {
        this.formData = JSON.parse(
          JSON.stringify(
            this.$route.params.surveys_id ? this.survey : this.surveyData
          )
        );
        this.formData.depths =
          this.formData.depths != undefined
            ? JSON.parse(this.formData.depths)
            : [];
        this.selectedDepths = this.formData.depths;
        this.generateDepthList(true);
        if (!this.pwaVersion && this.locationType == "google") {
          setTimeout(() => {
            this.$refs.googleAutoComplete.manuallySetPlace(
              this.formData.location
            );
          }, 100);
        }
      } else {
        this.formData = {
          date: moment().format("YYYY/MM/DD"),
          type: "Single Depth Moisture Survey",
          startingDepth: 200,
          locationType: "google",
          organizations: [],
        };

        // If you dont define the values as Null, then it might break reactivity when you set it later on
        // this.formData = {
        //   date: null,
        //   type: null
        // };

        // this.formData.date = moment().format("YYYY/MM/DD");
        // this.formData.type = "Single Depth Moisture Survey";
      }
    },
    linkSurveysTogether() {
      this.linkToAnotherSurveyLoading = true;
      let data = {
        baseID: this.formData.id,
        ssID: this.ssLinkedID,
      };
      this.$refs.surveyForm.validate().then((result) => {
        if (result) {
          this.$store
            .dispatch("linkToScheduledSurveys", data)
            .then((result) => {
              this.linkToAnotherSurveyLoading = false;
              if (result.Result == "Success") {
                this.linkToAnotherSurveyDialog = false;
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message,
                });
              }
            });
        } else {
          this.$emit("loadingStateChanged", false);
        }
      });
    },
    dateOptionsFn(date) {
      return date >= moment().format("YYYY/MM/DD");
    },
    generateDepthList(skipSelectedDepths = false) {
      if (
        this.formData.type == "Moisture Profile Survey" &&
        this.formData.depthInterval
      ) {
        this.depths = [];
        let finished = false;
        let depth = JSON.parse(JSON.stringify(this.formData.startingDepth));
        while (!finished) {
          let newDepth = depth + this.formData.depthInterval;
          if (newDepth >= 300) {
            newDepth = 300;
            finished = true;
          }
          this.depths.push({
            label: `${depth}mm-${newDepth}mm`,
            value: depth,
            disabled: depth == this.formData.startingDepth,
          });
          if (!skipSelectedDepths) {
            this.selectedDepths.push(depth);
          }
          depth = newDepth;
        }
      }
    },
    selectDepth(depth) {
      if (this.selectedDepths.includes(depth.value)) {
        this.selectedDepths = this.selectedDepths.filter(
          (d) => d != depth.value
        );
      } else {
        this.selectedDepths.push(depth.value);
      }
    },
    placeSelected(place) {
      this.formData.location = place.formatted_address;
      this.formData.locationJSON = JSON.stringify(place);
    },
    async create() {
      this.$emit("loadingStateChanged", true);
      this.$refs.surveyForm.validate().then((result) => {
        if (result) {
          this.formData.depths = this.selectedDepths;
          console.log(this.formData);
          this.$store
            .dispatch("newScheduledSurvey", this.formData)
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$emit("close", true);
                this.formData = {};
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message,
                });
              }
            });
        } else {
          this.$emit("loadingStateChanged", false);
        }
      });
    },
    save() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.formData.depths = this.selectedDepths;

        this.$store
          .dispatch("saveScheduledSurvey", this.formData)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              if (this.$route.name == "reportingView") {
                this.$store.dispatch("loadSurveyByID", this.formData.id);
              }
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "Scheduled Survey has been saved",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      });
    },
    createMergedSurvey() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.formData.depths = this.selectedDepths;
        this.formData.scans = this.scansToBeMerged;

        this.$store
          .dispatch("createMergedSurvey", this.formData)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.address = "";
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "Survey has been merged",
              });
              this.$router.push(`/reporting/${result.Response.id}`);
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      });
    },
    uploadData() {
      this.$q.notify({
        message:
          "Warning, uploading data will clear all previous scan data at this depth for this survey.",
        color: "warning",
        position: "center",
        timeout: 0,
        actions: [
          {
            label: "Proceed",
            color: "red",
            handler: () => {
              this.$refs.uploadDataInput.$el.click();
              this.$emit("uploadDataLoading", true);
            },
          },
        ],
      });
    },
    uploadDataReady() {
      let reader = new FileReader();
      reader.readAsText(this.file[0]);
      reader.onload = () => {
        this.$store
          .dispatch("uploadSurveyScanData", {
            id: this.formData.id,
            data: JSON.parse(reader.result),
          })
          .then((res) => {
            this.$q.notify({
              message: "Data Uploaded",
              color: "positive",
            });
            this.file = null;
            this.$emit("uploadDataLoading", false);
          });
      };
    },
  },
};
</script>
